import { store } from '../store/premiumTravelStore';
import { mutatorAction } from 'satcheljs';
import { GetTravelAssistantDataResponse } from '../services/GetTravelAssistantDataResponse';
import { OwaDate, userDate, isBefore, addHours } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';

export default mutatorAction('persistResponse', function persistResponse(
    response: [GetTravelAssistantDataResponse]
) {
    /// perform a null check to see if response returned a lastModifiedDateTime
    if (response.length && response[0].lastModifiedDateTime) {
        // activate the travel Assistant service if it was modified in the last 48 hours
        var lastModifiedDateTime: OwaDate = userDate(response[0].lastModifiedDateTime);
        store.isActivated = isBefore(addHours(observableToday(), -48), lastModifiedDateTime);
        if (store.isActivated) {
            store.savings = response[0].savings;
        }
    }
});
